import { Suspense, useCallback, useContext, useEffect, useState } from "react";
import { TostMsg } from "../../../../App";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Dropdown } from "primereact/dropdown";
import {
  addEmployeeBadge,
  deleteEmployeeBadge,
  getEmployeeBadge,
  getOrgBadge,
} from "../Service/profileService";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
import ComponentLoader from "../../../../Shared/Sidebar/ComponentLoader";
import { getRawPermissionsArray } from "../../../../Routes/AuthGard/usePermissions";

const Badges = ({employeeId }) => {
  const [BadgeData, setBadgeList] = useState();
  const [Isloading, setIsloading] = useState(false);
  const toster = useContext(TostMsg);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [employeeList, setEmployeeList] = useState(null);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  let userPermissions = getRawPermissionsArray();
  const defaultImage = "/images/org-img/profile/badge.png";
  const [badgesId, setBadgesId] = useState(0);
  const [showContent, setSeleteContent] = useState([]);
  const [create, setCreate] = useState(false);
  const [update, setUpdate] = useState(false);
  const [deleted, setDeleted] = useState(false);
  useEffect(() => {
    if (employeeId) {
      getEmployeeBadgeList();
    }
    getOrgBadgeData();
    permissionAccouncement();
  }, [employeeId]);

  const permissionAccouncement = () => {
    userPermissions?.map((UserPermission) => {
      if (UserPermission.PermissionName == "Badge.Add") {
        setCreate(true);
      } else if (UserPermission.PermissionName == "Badge.Edit") {
        setUpdate(true);
      } else if (UserPermission.PermissionName == "Badge.Delete") {
        setDeleted(true);
      }
    });
  };

  async function getOrgBadgeData() {
    var params = {
      OrgId: userDetails?.OrgId,
    };
    try {
      let OrgBadgeList = await getOrgBadge(params);
      setEmployeeList(OrgBadgeList.Data);
    } catch (error) {
      setIsloading(false);
    }
  }

  const employeeOptionTemplate = (option) => {
    return (
      <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
        <img
          alt={option.BadgeName}
          src={option.BadgeIconPath || defaultImage}
          onError={handleImageError}
          width="50"
          height="50"
        />
        <span>{option.BadgeName}</span>
      </div>
    );
  };
  const getOptionDisabled = (option) =>
    BadgeData?.some(
      (badge) =>
        badge.BadgeName === option.BadgeName &&
        badge.BadgeIconPath === option.BadgeIconPath &&
        badge.OrgId === option.OrgId
    );

  const handleCloseAppreciationModal = () => {
    document.querySelector("#add-badg .btn-close")?.click();
    badgeFrom.resetForm();
  };

  const badgeValidation = Yup.object().shape({
    BadgeById: Yup.string().required("Badge is required."),
  });

  const badgeFrom = useFormik({
    initialValues: {
      BadgeById: "",
    },
    validationSchema: badgeValidation,
    onSubmit: async (data) => {
      setIsloading(true);
      const body = {
        Id: data?.id ?? 0,
        OrgId: userDetails.OrgId,
        EmpId: employeeId,
        BadgeId: data?.BadgeById,
        ModifiedBy: userDetails.EmpId,
      };
      try {
        await addEmployeeBadge(body);
        if (!data?.id) {
          setIsloading(false);
          GetMasterSystemAlertList("badge_added_successfully", 0);
        } else {
          setIsloading(false);
          GetMasterSystemAlertList("badge_update_successfully", 0);
        }
        document.querySelector("#add-badg .btn-close")?.click();
        getEmployeeBadgeList();
        handleCloseAppreciationModal();
      } catch (error) {
        toster.current.error(ERROR_LIST.DefaultError);
      } finally {
        setIsloading(false);
      }
    },
  });

  async function getEmployeeBadgeList() {
    const params = {
      OrgId: userDetails.OrgId,
      Id: 0,
      EmpId: employeeId,
    };
    try {
      const response = await getEmployeeBadge(params);
      let BadgeDatalist = response?.Data;
      setBadgeList(BadgeDatalist);
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  async function editBadges(editBadgesDetails) {
    if (editBadgesDetails) {
      setBadgesId(editBadgesDetails.id);
      const editBadgesDetailsData = {
        id: editBadgesDetails?.Id,
        BadgeById: editBadgesDetails?.BadgeId,
      };
      badgeFrom.setValues(editBadgesDetailsData);
    }
  }

  async function deleteBadge() {
    setIsloading(true);
    if (badgesId) {
      const body = {
        Id: badgesId,
        ModifiedBy: userDetails.EmpId,
      };
      try {
        let response = await deleteEmployeeBadge(body);
        if (response) {
          GetMasterSystemAlertList("badge_deleted_successfully", 0);
          getEmployeeBadgeList();
        }
        setIsloading(false);
      } catch (error) {
        setIsloading(false);
        toster.current.error(ERROR_LIST.DefaultError);
      }
    }
  }

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setSeleteContent(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setSeleteContent(msg?.Desc);
      }
    });
  }, []);

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage; 
  }, []);

  const addBadges = () => {
    badgeFrom.resetForm();
    setBadgesId(0);
  };

  return (
    <div>
      {(BadgeData?.length != 0 || create) && (
        <div className="profile-about-me">
          <div className="pt-3 border-bottom-1">
            <div className="mb-0">
              <h4 className="text-primary mb-3 sumh4 addprofile-action">
                Badges
                {create && (
                  <span
                    style={{
                      background: "#fbfbfb",
                      float: "right",
                    }}
                  >
                    <a
                      className="edit-btncss mb-2 love-icon"
                      data-bs-toggle="modal"
                      data-bs-target="#add-badg"
                      title="Add Badge"
                      aria-label="Badge"
                      onClick={() => {
                        addBadges();
                        GetMasterSystemAlertList("show_achievement_badge", 1);
                      }}
                    >
                      <img
                        src="/images/org-img/profile/add.png"
                        className="w-100"
                      />
                    </a>
                  </span>
                )}
              </h4>
              <div className="row">
                {BadgeData?.map((badge) => {
                  return (
                    <div className="col-12 mb-3 col-md-6">
                      <div className="project-1">
                        <img
                          src={badge.BadgeIconPath || defaultImage}
                          onError={handleImageError}
                          className="float-img"
                        />
                        <strong>{badge?.BadgeName}</strong>
                        <div className="hover-badges-box">
                          {deleted && (
                            <img
                              onClick={() => {
                                setBadgesId(badge?.Id);
                              }}
                              src="/images/org-img/delete.png"
                              aria-label="Badge"
                              title="Delete"
                              data-bs-toggle="modal"
                              data-bs-target="#delete-badg"
                            />
                          )}
                          {update && (
                            <img
                              onClick={() => {
                                editBadges(badge);
                                GetMasterSystemAlertList("update_badge", 1);
                              }}
                              aria-label="Badge"
                              src="/images/org-img/edit.png"
                              title="Edit Badge"
                              data-bs-toggle="modal"
                              data-bs-target="#add-badg"
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div
                className="modal fade"
                id="delete-badg"
                tabIndex="-1"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content delete-holiday">
                    <div className="modal-header">
                      <img
                        src="/images/org-img/leave/popup-backimg.png"
                        className="backimg"
                      />
                      <div className="img">
                        <img src="/images/org-img/leave/trash.png" />
                      </div>
                    </div>
                    <div className="modal-body text-center">
                      <strong className="modal-title">Are you sure?</strong>
                      <p>Do you really want to delete this Badge?</p>
                    </div>
                    <div className="modal-footer m-auto">
                      <button
                        type="button"
                        className="cancelbtn-click"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="deletebtn-click"
                        data-bs-dismiss="modal"
                        onClick={() => deleteBadge()}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="modal fade custom-modal-area"
                id="add-badg"
                tabIndex="-1"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content add-editbadge">
                    <div className="modal-header">
                      <img
                        src="/images/org-img/leave/popup-backimg.png"
                        className="backimg"
                      />
                      <div className="img">
                        <img src="/images/popup-icons/featured-post.png" />
                      </div>
                      <button
                        onClick={handleCloseAppreciationModal}
                        type="button"
                        className="btn-close m-auto"
                        data-bs-dismiss="modal"
                      ></button>
                    </div>
                    <div className="modal-body text-center">
                      <strong className="modal-title">
                        {badgesId != 0 ? (
                          <h5 className="modal-title m-auto">Edit Badge</h5>
                        ) : (
                          <h5 className="modal-title m-auto">Add Badge</h5>
                        )}
                      </strong>
                      <p>{showContent}</p>
                      <div className="addcourseform">
                        <form onSubmit={badgeFrom.handleSubmit}>
                          <div className="row">
                            <div className="mb-4 col-md-12 mt-3">
                              <label className="form-label">
                                Select Badge
                                <i className="inValidError">*</i>
                              </label>
                              <div className="">
                                <Dropdown
                                  optionDisabled={getOptionDisabled}
                                  value={badgeFrom.values.BadgeById}
                                  name="BadgeById"
                                  options={employeeList}
                                  onChange={(e) =>
                                    badgeFrom.setFieldValue(
                                      "BadgeById",
                                      e.value
                                    )
                                  }
                                  optionLabel="BadgeName"
                                  optionValue="Id"
                                  className={
                                    "w-full md:w-14rem" +
                                    (badgeFrom.errors.BadgeById &&
                                    badgeFrom.touched.BadgeById
                                      ? " is-invalid"
                                      : "")
                                  }
                                  appendTo="self"
                                  itemTemplate={employeeOptionTemplate}
                                  filter={true}
                                  placeholder="Choose..."
                                  checkmark={true}
                                  highlightOnSelect={false}
                                />
                              </div>
                              <div className="invalid-feedback">
                                {badgeFrom.errors.BadgeById &&
                                badgeFrom.touched.BadgeById
                                  ? badgeFrom.errors.BadgeById
                                  : null}
                              </div>
                            </div>
                          </div>
                          <div className="modal-footer m-auto justify-content-center">
                            <button
                              type="button"
                              className="cancelbtn-click"
                              data-bs-dismiss="modal"
                              onClick={handleCloseAppreciationModal}
                            >
                              Cancel
                            </button>
                            {badgesId != 0 ? (
                              <button
                                type="submit"
                                className="savebtn-click"
                                disabled={Isloading}
                              >
                                {Isloading ? "Please wait..." : "Update"}
                              </button>
                            ) : (
                              <button
                                type="submit"
                                className="savebtn-click"
                                disabled={Isloading}
                              >
                                {Isloading ? "Please wait..." : "Save"}
                              </button>
                            )}
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {Isloading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
};
export default Badges;
